import { useEffect, useState } from 'react';

import { isSSR } from '~/shared/utils/platform/utils/platform';

/**
 * Hook to detect if user prefers reduced motion
 * Returns true if user has set prefers-reduced-motion: reduce
 */
export const useReducedMotion = () => {
	const [prefersReducedMotion, setPrefersReducedMotion] = useState(false);

	useEffect(() => {
		if (isSSR) return;

		const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

		const handleChange = (event: MediaQueryListEvent) => {
			setPrefersReducedMotion(event.matches);
		};

		// Set initial value
		setPrefersReducedMotion(mediaQuery.matches);

		// Listen for changes
		mediaQuery.addEventListener('change', handleChange);

		return () => {
			mediaQuery.removeEventListener('change', handleChange);
		};
	}, []);

	return prefersReducedMotion;
};
